import getPrescriberCity from 'utils/print/getPrescriberCity';
import getPrescriberState from 'utils/print/getPrescriberState';

const getPrescriberCityState = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const city = getPrescriberCity(otherProps);
  const state = getPrescriberState(otherProps);

  if (city && state) {
    return `${city}, ${state}`;
  } else if (city) {
    return city;
  }

  return null;
};

export default getPrescriberCityState;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberCityState.js